import { render, staticRenderFns } from "./FormInstructionsPane.vue?vue&type=template&id=f79648d0&"
import script from "./FormInstructionsPane.vue?vue&type=script&lang=js&"
export * from "./FormInstructionsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports